module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/core-js@2.6.12/~/core-js/library/modules/_library.js
// module id = oP+w
// module chunks = 5